import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "confirmation-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Dialog, {
      visible: _ctx.deleteDialog,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.deleteDialog) = $event)),
      visibleModifiers: { sync: true },
      style: {width: '450px'},
      header: _ctx.headerLabelComponent,
      modal: true,
      onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeDialog()))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.$t('Squeeze.General.No'),
          icon: "mdi mdi-close",
          class: "p-button-text",
          onClick: _ctx.closeDialog
        }, null, 8, ["label", "onClick"]),
        _createVNode(_component_Button, {
          label: _ctx.$t('Squeeze.General.Yes'),
          icon: "mdi mdi-check",
          class: "p-button-text",
          onClick: _ctx.deleteEntry
        }, null, 8, ["label", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.severity)
            ? (_openBlock(), _createBlock(_component_Message, {
                key: 0,
                severity: _ctx.severity,
                closable: false
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.messageLabelComponent), 1)
                ]),
                _: 1
              }, 8, ["severity"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[2] || (_cache[2] = _createElementVNode("i", {
                  class: "mdi mdi-message-alert-outline p-mr-3",
                  style: {"font-size":"1rem"}
                }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.messageLabelComponent), 1)
              ], 64))
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ]))
}